export const accessTypes = {
  applicationSpecific: "applicationSpecific",
  global: "global",
  marketSpecific: "marketSpecific"
};

export const accessTypeOptions = [
  { id: accessTypes.applicationSpecific, value: "Application Specific" },
  { id: accessTypes.global, value: "Global" },
  { id: accessTypes.marketSpecific, value: "Market Specific" }
];
